<script>
import CrmPointsCard from "@/components/crm/CrmPointsCard.vue";
import CrmPrivilegeCard from "@/components/crm/CrmPrivilegeCard.vue";
import CrmNewsCard from "@/components/crm/CrmNewsCard.vue";
import StandardV2BannerCarousel from "@/components/profile/StandardV2BannerCarousel.vue";

import CrmSummaryCards from "@/components/crm/CrmSummaryCards.vue";
import CrmRedeemNowCard from "@/components/crm/CrmRedeemNowCard.vue";
import Mission from "@/components/profile/Mission";
import ModalLoading from "@/components/other/ModalLoading.vue";
export default {
  name: "StandardV2Home",
  components: {
    CrmPointsCard,
    CrmNewsCard,
    Mission,
    CrmPrivilegeCard,
    CrmRedeemNowCard,
    CrmSummaryCards,
    ModalLoading,
    StandardV2BannerCarousel
  },
  data() {
    return {
      langs: this.$cookies.isKey("lang") ? this.$cookies.get("lang") : {},
      languageList: this.$store.state.languageList,
      privilegeList: [],
      rewardList: [],
      newsList: [],
      isLoadingPrivilege: true,
      isLoadingReward: true,
      isLoadingNews: true,
      showSummaryStub:
        this.$store.state.theme.line_display_service_outstanding == "1"
          ? true
          : false,
      creditAndPackge: {
        current_credit: 0,
        total_package: 0,
        total_voucher: 0
      }
    };
  },
  computed: {
    profile() {
      return this.$store.state.shortProfile || {};
    },
    lineProfile() {
      return this.$cookies.get("user_profile_token") || {};
    },
    avatar() {
      return (
        this.lineProfile.pictureUrl ||
        this.profile.image_url ||
        this.handleImageSrc
      );
    },
    displayName() {
      const profileName = `${this.profile.first_name_th || ""} ${
        this.profile.last_name_th || ""
      }`.trim();
      return profileName || this.lineProfile.displayName || "-";
    },
    latestPrivileges() {
      return this.privilegeList.slice(0, 5);
    },
    latestRewards() {
      return this.rewardList.slice(0, 5);
    },
    latestNews() {
      return this.newsList.slice(0, 5);
    },
    showLanguageSwitcher() {
      return this.languageList.length > 1;
    },
    currentLanguage() {
      return (
        this.languageList.find(lang => lang.id == this.langs.lang) ||
        this.languageList[0] ||
        {}
      );
    }
  },
  async created() {
    await this.getLanguageList();
    this.getPrivilegeList();
    this.getRewardList();
    this.getNewsList();
    this.getCreditAndPackage();
  },
  watch: {
    "$route.path"() {
      if (this.$cookies.isKey("lang")) this.langs = this.$cookies.get("lang");
    }
  },
  methods: {
    async getLanguageList() {
      if (this.$store.state.languageList.length == 0) {
        const res = await this.$store.dispatch("getLanguage");
        this.languageList = res;
        return;
      }

      this.languageList = this.$store.state.languageList;
    },
    async changeLang(val) {
      const index = this.languageList.findIndex(el => el.id == val);
      if (index < 0 || this.langs.lang == val) return;

      this.$refs.modalLoading.show();
      try {
        const selectedLanguage = this.languageList[index];
        const payload = {
          lang: selectedLanguage.id,
          name: selectedLanguage.name,
          flag: selectedLanguage.image_url
        };

        await this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            lang_id: String(selectedLanguage.id)
          }
        });
        await this.$cookies.set("lang", JSON.stringify(payload));
        this.langs = payload;
        await this.$getLang();
        await this.$store.dispatch("getProvince", false);
        await this.$store.dispatch("refreshUserProfile");
      } finally {
        this.$refs.modalLoading.hide();
      }
    },
    async getPrivilegeList() {
      this.isLoadingPrivilege = true;
      try {
        const data = await this.$axios.get(`/api/v1/Privilege/privilege_list`);
        if (data.result == 1) {
          this.privilegeList = data.detail.filter(el => {
            if (!el.prefix && el.coupon_code_type == 3) return false;
            if (el.availability == 1) return true;
            return el.already_use == 0;
          });
        }
      } catch (_) {
        this.$logger({
          response: _?.response || {
            config: _?.config || {
              url: "/api/v1/Privilege/privilege_list",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getPrivilegeList API request failed" }
        });
        this.privilegeList = [];
      } finally {
        this.isLoadingPrivilege = false;
      }
    },
    async getRewardList() {
      this.isLoadingReward = true;
      try {
        const data = await this.$axios("/api/v1/user/GetRedeemReward");
        if (data.result == 1) this.rewardList = data.detail || [];
      } catch (_) {
        this.$logger({
          response: _?.response || {
            config: _?.config || {
              url: "/api/v1/user/GetRedeemReward",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getRewardList API request failed" }
        });
        this.rewardList = [];
      } finally {
        this.isLoadingReward = false;
      }
    },
    async getCreditAndPackage() {
      try {
        const data = await this.$axios.get(`/api/v1/Service/spa_detail`);
        if (data.result == 1) this.creditAndPackge = data.detail;
      } catch (_) {
        this.$logger({
          response: _?.response || {
            config: _?.config || {
              url: "/api/v1/Service/spa_detail",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getCreditAndPackage API request failed" }
        });
        this.creditAndPackge = {
          current_credit: 0,
          total_package: 0,
          total_voucher: 0
        };
      }
    },
    async getNewsList() {
      this.isLoadingNews = true;
      try {
        const data = await this.$axios.post(`/api/v1/MonthlyPrivilege/list`, {
          page: 1,
          take: 5,
          id: []
        });
        if (data.result == 1) this.newsList = data.detail.detail || [];
      } catch (_) {
        this.$logger({
          response: _?.response || {
            config: _?.config || {
              url: "/api/v1/MonthlyPrivilege/list",
              method: "POST",
              methods: "POST",
              data: ""
            }
          },
          action: { id: 3, action: "getNewsList API request failed" }
        });
        this.newsList = [];
      } finally {
        this.isLoadingNews = false;
      }
    },
    goPrivilege(item) {
      this.$router.push(
        `/privilege/${item.promotion_id}?user_coupon_id=${item.user_coupon_id}`
      );
    },
    goReward(item) {
      this.$router.push(`/reward/${item.id}?type=${item.product_type}&o_id=0`);
    },
    goNews(item) {
      this.$router.push(`/news/${item.id}`);
    }
  }
};
</script>

<template>
  <!-- <StandardV2Layout> -->
  <!-- <section class="standard-v2-home__top">
    <div class="standard-v2-home__user">
      <c-img-lazy :src="avatar" class="standard-v2-home__avatar" />
      <span class="standard-v2-home__name">{{ displayName }}</span>
    </div>
    <div
      v-if="showLanguageSwitcher"
      class="standard-v2-home__language"
      data-test="home-header-language"
    >
      <v-menu location="bottom end">
        <template v-slot:activator="{ props }">
          <button
            type="button"
            class="standard-v2-home__language-btn"
            v-bind="props"
            data-test="home-header-language-btn"
            :aria-label="$t('language')"
          >
            <span class="flag-lang">{{ currentLanguage.image_url }}</span>
            <span>{{ currentLanguage.display_name }}</span>
            <font-awesome-icon icon="chevron-down" />
          </button>
        </template>

        <v-list data-test="home-header-language-menu">
          <v-list-item
            v-for="lang in languageList"
            :key="'standard-v2-lang-' + lang.id"
            :data-test="`home-header-language-item-${lang.id}`"
            @click="changeLang(lang.id)"
          >
            <div class="standard-v2-home__language-item">
              <span class="flag-lang">{{ lang.image_url }}</span>
              <span data-lang="profile">{{ lang.display_name }}</span>
              <font-awesome-icon
                v-if="lang.id == langs.lang"
                icon="check"
                class="standard-v2-home__language-check"
              />
            </div>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </section> -->

  <CrmPointsCard :profile="profile" data-test="home-hero-points-card" />
  <section id="spa-wallet">
    <div class="standard-v2-home__section-header mt-3">
      <h2>{{ $t("spa_wallet") }}</h2>
      <router-link
        to="/spa-wallet"
        class="v2__all"
        data-test="home-spa-wallet-section-see-all"
      >
        {{ $t("see_all") }}
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      </router-link>
    </div>
    <CrmSummaryCards
      v-if="showSummaryStub"
      :credit="creditAndPackge.current_credit"
      :package-count="creditAndPackge.total_package"
      :voucher-count="creditAndPackge.total_voucher"
    />
  </section>
  <div class="standard-v2-home__banner-full">
    <StandardV2BannerCarousel
      :profile="profile"
      data-test-prefix="home-banner-carousel-v2"
    />
  </div>
  <!-- TODO: wire service outstanding/upcoming redeem data -->
  <section class="standard-v2-home__section" id="mission">
    <Mission v-if="displayMission" />
  </section>
  <section
    class="standard-v2-home__section"
    v-if="latestPrivileges.length !== 0"
  >
    <div class="standard-v2-home__section-header">
      <h2>{{ $t("privilege") }}</h2>
      <router-link
        to="/privilege"
        class="v2__all"
        data-test="home-privilege-section-see-all"
      >
        {{ $t("see_all") }}
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      </router-link>
    </div>
    <div
      v-if="isLoadingPrivilege"
      class="standard-v2-home__state"
      data-test="home-privilege-loading"
    >
      {{ $t("loading") }}
    </div>

    <div v-else class="standard-v2-home__horizontal-list">
      <CrmPrivilegeCard
        v-for="item in latestPrivileges"
        :key="item.user_coupon_id || item.promotion_id"
        :item="item"
        compact
        :data-test="`home-privilege-card-${
          item.user_coupon_id || item.promotion_id
        }`"
        @select="goPrivilege"
        @use="goPrivilege"
      />
    </div>
  </section>

  <section
    class="standard-v2-home__section"
    v-if="displayUpcomming && latestRewards.length !== 0"
  >
    <div class="standard-v2-home__section-header">
      <h2>{{ $t("reward_redeem_now_title") }}</h2>

      <router-link
        to="/reward"
        class="v2__all"
        data-test="home-reward-section-see-all"
      >
        {{ $t("see_all") }}
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      </router-link>
    </div>
    <div
      v-if="isLoadingReward"
      class="standard-v2-home__state"
      data-test="home-reward-loading"
    >
      {{ $t("loading") }}
    </div>

    <div v-else class="standard-v2-reward__redeem-now-list">
      <CrmRedeemNowCard
        v-for="item in latestRewards"
        :key="item.id"
        :item="item"
        :data-test="`home-reward-card-${item.id}`"
        @select="goReward"
      />
    </div>
  </section>

  <section class="standard-v2-home__section" v-if="latestNews.length > 0">
    <div class="standard-v2-home__section-header">
      <h2>{{ $t("news") }}</h2>

      <router-link
        to="/news"
        class="v2__all"
        data-test="home-news-section-see-all"
      >
        {{ $t("see_all") }}
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      </router-link>
    </div>
    <div
      v-if="isLoadingNews"
      class="standard-v2-home__state"
      data-test="home-news-loading"
    >
      {{ $t("loading") }}
    </div>

    <div v-else>
      <CrmNewsCard
        v-for="item in latestNews"
        :key="item.id"
        :item="item"
        date-format="DD MMM YYYY HH:mm"
        show-date-label
        :data-test="`home-news-card-${item.id}`"
        @select="goNews"
      />
    </div>
  </section>
  <!-- </StandardV2Layout> -->
  <ModalLoading ref="modalLoading" />
</template>

<style lang="scss" scoped>
.standard-v2-home__banner-full {
  margin-left: -1rem;
  margin-right: -1rem;
}

.standard-v2-home__top,
.standard-v2-home__user,
.standard-v2-home__section-header {
  display: flex;
  align-items: center;
}

.standard-v2-home__top {
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.standard-v2-home__user {
  min-width: 0;
  gap: 8px;
}

.standard-v2-home__avatar {
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 50%;
}

.standard-v2-home__name {
  overflow: hidden;
  max-width: 160px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}

.standard-v2-home__language {
  flex: 0 0 auto;
}

.standard-v2-home__language-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 34px;
  padding: 6px 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  background: #fff;
  color: var(--text-color);
  font-size: var(--font-helper);
  font-weight: 700;
  box-shadow: var(--crm-box-shadow);
}

.standard-v2-home__language-item {
  display: flex;
  min-width: 140px;
  align-items: center;
  gap: 8px;
}

.standard-v2-home__language-check {
  margin-left: auto;
  color: var(--primary-color);
}

.standard-v2-home__section {
  margin-top: 24px;
}

.standard-v2-home__section-header {
  justify-content: space-between;
  margin-bottom: 15px;
}

.standard-v2-home__section-header h2 {
  margin: 0;
  font-size: var(--font-title-sm);
  font-weight: 900;
}

.standard-v2-home__section-header button {
  border: 0;
  background: transparent;
  font-size: var(--font-body);
  font-weight: 800;
  text-decoration: underline;
}

.standard-v2-home__horizontal-list {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;
}

.standard-v2-home__horizontal-list::-webkit-scrollbar {
  display: none;
}

.standard-v2-reward__redeem-now-list {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 0 0px 4px;
  scrollbar-width: none;
}

.standard-v2-reward__redeem-now-list::-webkit-scrollbar {
  display: none;
}

.standard-v2-home__state {
  padding: 18px 12px;
  border-radius: 12px;
  background: #fff;
  color: #a0a0a0;
  text-align: center;
}
</style>
